<!--
	Wrapper component: renderless. The script owns state; the template only exposes it
	through a scoped slot and renders no markup of its own. Twig owns every line of markup
	inside <local-state …> and binds to the slot with v-slot="{ state }", v-model="state.x",
	v-show, and ${ }. The initial values arrive as an object on the :initial attribute.
	It exists for inline local state that is not worth a dedicated wrapper.
-->
<template>
	<slot v-bind="{ state }" />
</template>

<script setup>
import { reactive } from "vue";

const props = defineProps({
	initial: {
		type: Object,
		default: () => ({}),
	},
});

const state = reactive({ ...props.initial });
</script>
